<!-- A generative AI model wrote or edited portions of this file with the supervision of a human developer and careful human review. -->
<script>
  import { getContext } from "svelte";

  const { yScale, width } = getContext("LayerCake");

  let {
    value = 0,
    label = "",
    color = "#000",
    outlineColor = "#F5F5F5",
    dashArray = "10 10",
    strokeWidth = 2,
    outlineWidth = 3,
  } = $props();

  let yPos = $derived($yScale(value));
</script>

{#if value != null}
  <line
    x1={0}
    x2={$width}
    y1={yPos}
    y2={yPos}
    stroke={outlineColor}
    stroke-dasharray={dashArray}
    stroke-width={outlineWidth}
    stroke-linecap="square"
  />
  <line
    x1={0}
    x2={$width}
    y1={yPos}
    y2={yPos}
    stroke={color}
    stroke-dasharray={dashArray}
    stroke-width={strokeWidth}
    stroke-linecap="butt"
  />
  {#if label}
    <text
      x={$width + 8}
      y={yPos}
      dy="0.35em"
      fill={color}
      class="ref-label"
    >{label}</text>
  {/if}
{/if}

<style>
  .ref-label {
    font-weight: var(--font-weight-bold);
    font-size: 14px;
  }
</style>
